class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.spinner = this.querySelector('.loading-overlay__spinner');
    this.grid = document.getElementById('product-grid');
    this.nextUrl = this.dataset.nextUrl;

    if (this.button) {
      this.button.addEventListener('click', this.loadMoreItems.bind(this));
    }
  }

  async loadMoreItems() {
    // 1. Show spinner, hide text
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    this.spinner.classList.remove('hidden');

    try {
      // 2. Fetch the next page using Section Rendering API
      // We add '&section_id=main-collection-product-grid' to get ONLY the product grid, not the whole page
      const response = await fetch(`${this.nextUrl}&section_id=main-collection-product-grid`);
      const responseText = await response.text();

      // 3. Parse the response
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      // 4. Extract the new product items
      const newProducts = html.getElementById('product-grid').querySelectorAll('.grid__item');
      const newNextUrl = html.querySelector('load-more')?.dataset.nextUrl;

      // 5. Append new products to the current grid
      newProducts.forEach(product => {
        this.grid.appendChild(product);
      });

      // 6. Update the "Next URL" for the next click
      if (newNextUrl) {
        this.nextUrl = newNextUrl;
        this.dataset.nextUrl = newNextUrl;
      } else {
        // No more pages? Hide the button.
        this.style.display = 'none';
      }

    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      // 7. Reset button state
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
      this.spinner.classList.add('hidden');
    }
  }
}

customElements.define('load-more', LoadMore);